import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Title } from '@angular/platform-browser';
import { ProductService } from 'src/app/service/product.service';
import { ToastrNotificationService } from 'src/app/service/toastr-notification.service';
import { ClaimedProductDetailsDialogComponent } from './claimed-product-details-dialog.component';

@Component({
  selector: 'app-claimed-products',
  templateUrl: './claimed-products.component.html',
  styleUrls: ['./claimed-products.component.scss'],
})
export class ClaimedProductsComponent implements OnInit {
  displayedColumns: string[] = [
    'productCode',
    'productName',
    'claimedItemName',
    'mfgDate',
    'registeredDate',
    'claimDate',
    'lastEligibleDate',
    'status',
    'action',
  ];

  dataSource: any = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  spinner: boolean = true;
  allClaimedProducts: any[] = [];

  constructor(
    private productService: ProductService,
    private titleService: Title,
    private toastr: ToastrNotificationService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('Claimed Products');
    this.loadClaimedProducts();
  }

  loadClaimedProducts(): void {
    this.spinner = true;
    this.productService.getClaimedProducts().subscribe({
      next: (response) => {
        this.spinner = false;
        if (response && response.success) {
          this.allClaimedProducts = response.claimedProducts || [];
        } else {
          this.allClaimedProducts = [];
        }
        this.dataSource = new MatTableDataSource(this.allClaimedProducts);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        // Filter specifically by Serial Number (productCode)
        this.dataSource.filterPredicate = (data: any, filter: string) => {
          const serial = (data.productCode || '').toLowerCase();
          return serial.includes(filter);
        };
      },
      error: (error) => {
        this.spinner = false;
        this.toastr.error(
          error.error?.error || error.message || 'Could not load Claimed Products',
          'Error'
        );
      },
    });
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  viewDetails(element: any): void {
    this.dialog.open(ClaimedProductDetailsDialogComponent, {
      width: '750px',
      maxWidth: '95vw',
      panelClass: 'claimed-details-dialog-panel',
      data: element,
    });
  }
}
